<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row class="mb-5" align="center" justify="center">
        <v-col>
          <h3>Pedidos por Nota</h3>
        </v-col>
        <v-col cols="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="true"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Mês de Referência"
                prepend-icon="mdi-calendar"
                readonly
                outlined
                dense
                hide-details
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" type="month" no-title scrollable @change="loadData" locale="pt-br"> </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!items.length"
            :dark="items.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>

      <v-data-table :items="items" :headers="headers" :loading="loading" ::items-per-page="100" fixed-header>
        <template v-slot:[`item.clientFullName`]="{ item }">
          <span class="text-capitalize"> {{ item.clientFirstName }} {{ item.clientLastName }} </span>
        </template>
        <template v-slot:[`item.amountTotal`]="{ item }">
          {{ item.amountTotal | formatFullMoney }}
        </template>
        <template v-slot:[`item.amountLiquid`]="{ item }">
          {{ item.amountLiquid | formatFullMoney }}
        </template>
        <template v-slot:[`item.amountOtherReceivers`]="{ item }">
          {{ item.amountOtherReceivers | formatFullMoney }}
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | formatFullDate }}
        </template>
        <template v-slot:[`item.orderAuthorizedDate`]="{ item }">
          {{ item.orderAuthorizedDate | formatFullDate }}
        </template>
        <template v-slot:[`item.consolidatedAt`]="{ item }">
          {{ item.consolidatedAt | formatFullDate }}
        </template>
        <template v-slot:[`item.invoicePath`]="{ item }">
          <v-tooltip left v-if="item.invoicePath">
            <template v-slot:activator="{ on }" color="amber">
              <v-btn icon color="green" @click="getInvoice(item)" v-on="on">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Download Nota Fiscal</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  data: () => ({
    items: [],
    headers: [
      { text: 'Pedido', value: 'orderId' },
      { text: 'Número Nota', value: 'orderNumber' },
      { text: 'Seller', value: 'sellerId' },
      { text: 'Cliente', value: 'clientFullName' },
      { text: 'Valor Total', value: 'amountTotal' },
      { text: 'Valor Wap', value: 'amountLiquid' },
      { text: 'Valor Seller ', value: 'amountOtherReceivers' },
      { text: 'Data Criação', value: 'createdAt' },
      { text: 'Data Autorização', value: 'orderAuthorizedDate' },
      { text: 'Data Consolidação ', value: 'consolidatedAt' },
      { text: 'Download Nota', value: 'invoicePath' },
    ],
    loading: false,
    date: null,
    menu: false,
  }),
  methods: {
    loadData() {
      const url = `${baseApiUrl}/finantial/orderConsolidated`

      const d = new Date()
      let date = this.formatDate(d)
      if (this.date) {
        date = this.date
      }

      this.loading = true
      axios
        .get(url, { params: { date } })
        .then((res) => {
          this.items = res.data
          this.loading = false
        })
        .catch(showError)
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month].join('-')
    },
    getInvoice(arquivo) {
      const url = `${baseApiUrl}/finantial/invoice`
      this.loading = true

      axios
        .get(url, {
          params: {
            sellerId: arquivo.sellerId,
            month: arquivo.month,
            year: arquivo.year,
          },
          responseType: 'blob',
        })
        .then((res) => {
          this.loading = false
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', arquivo.invoicePath)
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
      // .catch(showError)
    },

    downloadCSV() {
      const data = this.items
      const fileName = 'download-pedidos-por-nota'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style></style>
